import { Link } from "react-router-dom";
import { ReviewCell } from "./ReviewCell";
import { Sparkline } from "./Sparkline";
import { StatusPill, money, num } from "./meta";

function Change({ r }) {
  if (r.prev_amount === undefined) return <span className="text-slate-300">—</span>;
  const pct = r.change_pct;
  const txt = pct === null ? "new" : `${pct > 0 ? "▲" : pct < 0 ? "▼" : ""} ${Math.abs(pct).toLocaleString()}%`;
  const tone = r.jump ? "bg-amber-100 text-amber-800 font-semibold" : "text-slate-500";
  return (
    <>{money(r.prev_amount)}
      <span className={`mt-0.5 block w-fit rounded px-1.5 text-[11px] ${tone} ml-auto`} data-testid={`uc-domain-change-${r.domain}`}
            title={r.jump ? "Unusual change vs last cycle" : undefined}>{txt}</span></>
  );
}

/** One domain of a usage run. */
export function DomainRow({ r, cycle, labels, review }) {
  const calls = `/billing-sync/usage-charges/calls?domain=${encodeURIComponent(r.domain)}${cycle ? `&start=${cycle.start}&end=${cycle.through}` : ""}`;
  const detail = r.message || (r.reasons || []).join(" · ");
  return (
    <tr className="border-b border-slate-50 align-top text-xs hover:bg-slate-50/60" data-testid={`uc-domain-${r.domain}`}>
      <td className="px-4 py-2">
        <Link to={calls} className="font-medium text-slate-800 hover:text-emerald-700 hover:underline" data-testid={`uc-domain-calls-${r.domain}`}>{r.domain}</Link>
        <div className="text-[11px] text-slate-500">{r.territory}</div></td>
      <td className="px-3 py-2">{r.customer || <span className="text-slate-400">—</span>}
        {r.sub_id && <div className="font-mono text-[11px] text-slate-500">sub {r.sub_id}{r.several ? " · several active, first used" : ""}</div>}</td>
      <td className="px-3 py-2 text-right font-mono tabular-nums">{num(r.calls)}<div className="text-[11px] text-slate-500">{num(r.charged)} charged</div></td>
      <td className="px-3 py-2 text-right font-mono tabular-nums text-slate-600" data-testid={`uc-domain-current-${r.domain}`}>{r.current == null ? "—" : money(r.current)}</td>
      <td className="px-3 py-2 text-right font-mono font-semibold tabular-nums text-slate-900" data-testid={`uc-domain-amount-${r.domain}`}>
        <span className="inline-flex items-center gap-2"><Sparkline trend={r.trend} current={r.amount} labels={labels} testid={`uc-spark-${r.domain}`} />{money(r.amount)}</span></td>
      <td className="px-3 py-2 text-right font-mono tabular-nums text-slate-600" data-testid={`uc-domain-prev-${r.domain}`}><Change r={r} /></td>
      <td className="px-3 py-2"><StatusPill s={r.status} testid={`uc-domain-status-${r.domain}`} />
        {detail && <div className="mt-1 max-w-[260px] text-[11px] text-slate-500">{detail}</div>}</td>
      {review && <td className="px-3 py-2"><ReviewCell r={r} cycleKey={cycle?.key} canReview={review.canReview} onDone={review.onDone} /></td>}
    </tr>
  );
}
